import React from 'react';

export default function ProductCard({
    id,
    type,
    title,
    onProductClick,
    selected,
    isPromo = false
}) {
    return (
        <div
            className={`bg-white w-full md:h-20 h-20 p-4 border rounded-md shadow cursor-pointer overflow-hidden hover:bg-gray-50 hover:bg-opacity-20 hover:shadow-md transition duration-400 ${
                selected ? 'selected ring-2' : 'border-gray-200'
            }`}
            onClick={onProductClick(title, type, isPromo, id)}>
            <div className="flex flex-col justify-between h-full">
                <div className="text-base font-medium">{title}</div>
                {isPromo ? (
                    <div className="ml-auto">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 text-green-600"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round">
                            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                            <line x1="7" y1="7" x2="7.01" y2="7"></line>
                        </svg>
                    </div>
                ) : null}
            </div>
        </div>
    );
}
